import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class BinaryBytesUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Bytes(binary)'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: BinaryBytesUnitConverter;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!BinaryBytesUnitConverter.instance) {
      BinaryBytesUnitConverter.instance = new BinaryBytesUnitConverter();
    }
    return BinaryBytesUnitConverter.instance;
  }

  protected units = [
    'bit (b) - Bytes(binary)',
    'byte (B) - Bytes(binary)',
    'kibibyte (KiB)',
    'mebibyte (MiB)',
    'gibibyte (GiB)',
    'tebibyte (TiB)',
    'pebibyte (PiB)',
    'exbibyte (EiB)',
  ] as const;

  protected unitToBase = {
    'bit (b) - Bytes(binary)': 1,
    'byte (B) - Bytes(binary)': 8,
    'kibibyte (KiB)': 8 * 1024,
    'mebibyte (MiB)': 8 * 1024 ** 2,
    'gibibyte (GiB)': 8 * 1024 ** 3,
    'tebibyte (TiB)': 8 * 1024 ** 4,
    'pebibyte (PiB)': 8 * 1024 ** 5,
    'exbibyte (EiB)': 8 * 1024 ** 6,
  };
}
